var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16116",
    "data-name": "Group 16116",
    transform: "translate(-1536 -144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1536 144)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16117",
    "data-name": "Group 16117",
    transform: "translate(1541.54 150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11401",
    "data-name": "Path 11401",
    d: "M1.787,24.9c.145,0,.129-.005.322.008V20.4a.876.876,0,0,1,.875-.875H7.742V12.732L5.655,14.749a.612.612,0,0,0-.186.438v3.328a.272.272,0,1,1-.544,0V15.186a1.159,1.159,0,0,1,.352-.829l2.548-2.463a.278.278,0,0,1,.276-.062l4.571,1.536V12.31a.854.854,0,0,1,.895-.838.839.839,0,0,1,.838.838v1.642l1.2.4a1.152,1.152,0,0,1,.785,1.093V24.9a2.246,2.246,0,0,1,2.186,2.243v1.383a.682.682,0,0,1-.681.681H.681A.682.682,0,0,1,0,28.529V26.688A1.789,1.789,0,0,1,1.787,24.9Zm0,.544A1.244,1.244,0,0,0,.544,26.688v.285H3.183v-.285A1.267,1.267,0,0,0,1.787,25.446ZM2.653,20.4v4.65a1.789,1.789,0,0,1,1.074,1.638v.285H7.742v-6.9H2.984a.332.332,0,0,0-.331.331ZM13.86,12.31a.294.294,0,0,0-.294-.293.318.318,0,0,0-.351.293v1.242l.645.217Zm2.525,13.137v1.527h1.633A1.7,1.7,0,0,0,16.385,25.447Zm1.642,3.082V27.518H16.385v1.148h1.5A.137.137,0,0,0,18.027,28.529ZM15.841,15.446a.608.608,0,0,0-.415-.577l-7.141-2.4v1.482l5.933,1.994a.272.272,0,1,1-.173.516l-5.76-1.936v1.384L14.219,17.9a.272.272,0,1,1-.173.516l-5.76-1.936v1.384l5.933,1.994a.272.272,0,1,1-.173.516l-5.76-1.936V19.8h0v.028l5.933,1.994a.272.272,0,1,1-.173.516L8.286,20.4v1.384l3.7,1.245a.272.272,0,1,1-.173.516L8.286,22.357v6.309h2.35V25.839a.587.587,0,0,1,.745-.566l2.532.707a.673.673,0,0,1,.491.647v2.039h1.437ZM13.86,26.627a.128.128,0,0,0-.093-.123l-.975-.272v2.434H13.86V26.627Zm-1.612,2.039V26.08L11.235,25.8a.043.043,0,0,0-.055.042v2.827Zm-4.506,0V27.518H3.727v1.148Zm-7.2-.137a.137.137,0,0,0,.137.137h2.5V27.518H.544Z",
    transform: "translate(0 -11.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11402",
    "data-name": "Path 11402",
    d: "M116.17,341.88a.272.272,0,0,1-.087-.014l-1.01-.34a.272.272,0,0,1,.173-.516l1.01.34a.272.272,0,0,1-.087.53Z",
    transform: "translate(-102.038 -329.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11403",
    "data-name": "Path 11403",
    d: "M321.9,268.6h-2.668a.459.459,0,0,1-.459-.459v-.655a.459.459,0,0,1,.459-.459H321.9a.459.459,0,0,1,.459.459v.655A.459.459,0,0,1,321.9,268.6Zm-.085-1.028h-2.5v.484h2.5Z",
    transform: "translate(-315.346 -257.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11404",
    "data-name": "Path 11404",
    d: "M321.9,325.631h-2.668a.459.459,0,0,1-.459-.459v-.655a.459.459,0,0,1,.459-.459H321.9a.459.459,0,0,1,.459.459v.655A.459.459,0,0,1,321.9,325.631Zm-.085-1.028h-2.5v.484h2.5Z",
    transform: "translate(-315.346 -312.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11405",
    "data-name": "Path 11405",
    d: "M320.11,383.244h-.882a.459.459,0,0,1-.459-.459v-.655a.459.459,0,0,1,.459-.459h.882a.459.459,0,0,1,.459.459v.655A.459.459,0,0,1,320.11,383.244Zm-.085-1.028h-.712v.484h.712Z",
    transform: "translate(-313.56 -368.244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.f99024a9ae23cf102e61fcd952b3fc98.svg";
export { ForwardRef as ReactComponent };